import axios from 'axios';

/**
 * 获取字典
 */
function dic(data) {
  return axios.get('claim/v1/internation?', {params: data})
}

export default {
  dic
};



// WEBPACK FOOTER //
// ./src/interface.js